<div class="admin-workspace">
  <div class="wrapper">
    <div class="sidebar">
      <app-sidebar-cmp></app-sidebar-cmp>
      <div class="sidebar-background"></div>
    </div>
    <main class="main-panel d-flex flex-column">
      <app-navbar></app-navbar>
      <div class="full-content">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
  <ng-container
    *appRoleAccess="{
      permissions: { entity: Entity.CHATBOT, action: Action.READ },
      components: TenantComponents.CHATBOT,
    }"
  >
    <app-chatbot></app-chatbot>
  </ng-container>
</div>
